import { Button } from "primereact/button";
import { useCallback, useState } from "react";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectFilteredDefects } from "../../store/selectors/defectSelectors";
import { selectInspectionData } from "../../store/selectors/inspectionSelectors";
import { generateActionPlan } from "../../services/defectService";

export const GenerateActionPlanButton = () => {
  const inspection = useAppSelector(selectInspectionData);
  const defects = useAppSelector(selectFilteredDefects);

  const [loading, setLoading] = useState(false);

  const onExport = useCallback(() => {
    if (inspection && defects) {
      setLoading(true);
      const inspectionId = inspection.id;
      const defectIds = defects.map((defect) => defect.defectId);

      generateActionPlan(inspectionId, defectIds).finally(() => {
        setLoading(false);
      });
    }
  }, [inspection, defects]);

  return (
    <Button
      label="Action Plan"
      loading={loading}
      className="ml-3"
      icon="pi pi-download"
      onClick={onExport}
      data-cy="generate-items-button"
    />
  );
};
